import { render, staticRenderFns } from "./OpentpEdit.vue?vue&type=template&id=1da12e94"
import script from "./OpentpEdit.vue?vue&type=script&lang=js"
export * from "./OpentpEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports